import templateUrl from './feesTotalsTable.html';

export function FeesTotalsTableDirective(paymentService) {
    'ngInject';

    return {
        replace: true,
        restrict: 'EA',
        scope: true,
        templateUrl,
        link: function(scope, element, attrs) {
            scope.readOnlyTable = attrs.readOnlyTable;
            scope.getTipAmount = () => paymentService.getTipAmountForDisplay();
            scope.getTotalAmount = () => paymentService.getTotalAmountForDisplay();
            scope.isTipDisplayable = () => scope.getTipAmount() > 0;
        }
    };
}
